/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Notificationcenter_Markallread3Inputs */

const en_notificationcenter_markallread3 = /** @type {(inputs: Notificationcenter_Markallread3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mark all as read`)
};

/**
* | output |
* | --- |
* | "Mark all as read" |
*
* @param {Notificationcenter_Markallread3Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const notificationcenter_markallread3 = /** @type {((inputs?: Notificationcenter_Markallread3Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Notificationcenter_Markallread3Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_notificationcenter_markallread3(inputs)
});
export { notificationcenter_markallread3 as "notificationCenter_markAllRead" }